import React from 'react';

const TermsOfService = () => {
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1 style={{ textAlign: 'center' }}>Terms of Service for UrPoster</h1>
      <p><strong>Last Updated: April 15, 2025</strong></p>

      <p>Welcome to UrPoster! These Terms of Service ("Terms") govern your use of UrPoster, a social media scheduling application ("Service"), provided by UrPoster ("we," "us," or "our"). By accessing or using the Service, you agree to be bound by these Terms. If you do not agree, please do not use the Service.</p>

      <h2>1. Acceptance of Terms</h2>
      <p>By creating an account or using UrPoster, you confirm that you are at least 13 years old and agree to these Terms. If you are using the Service on behalf of a business or organization, you represent that you have the authority to bind that entity to these Terms.</p>

      <h2>2. Description of Service</h2>
      <p>UrPoster allows users to schedule and manage posts on social media platforms, including TikTok, Instagram, Twitter, and YouTube. You can upload media, set posting schedules, and connect your social media accounts to the Service. We do not control the content you post or the policies of the platforms you connect to.</p>

      <h2>3. User Accounts</h2>
      <ul>
        <li><strong>Registration</strong>: To use UrPoster, you must create an account with a valid username, email, and password. You are responsible for keeping your account information secure.</li>
        <li><strong>Account Activity</strong>: You are responsible for all activity under your account. Notify us immediately at support@urposter.com if you suspect unauthorized access.</li>
        <li><strong>Termination</strong>: We reserve the right to suspend or terminate your account if you violate these Terms or engage in harmful activity.</li>
      </ul>

      <h2>4. User Content</h2>
      <ul>
        <li><strong>Ownership</strong>: You retain ownership of the content you upload to UrPoster ("User Content"). By uploading, you grant us a non-exclusive, worldwide, royalty-free license to store, process, and transmit your User Content solely to provide the Service.</li>
        <li><strong>Responsibility</strong>: You are responsible for ensuring your User Content complies with all applicable laws and platform policies. Do not upload content that is illegal, harmful, or infringing on others’ rights.</li>
        <li><strong>Removal</strong>: We may remove User Content that violates these Terms or platform guidelines.</li>
      </ul>

      <h2>5. Acceptable Use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Use UrPoster to post harmful, illegal, or misleading content.</li>
        <li>Attempt to gain unauthorized access to the Service or its systems.</li>
        <li>Use the Service to spam, harass, or harm others.</li>
        <li>Reverse engineer, decompile, or otherwise interfere with the Service’s functionality.</li>
      </ul>

      <h2>6. Third-Party Platforms</h2>
      <p>UrPoster integrates with third-party platforms (e.g., TikTok, Instagram, Twitter, YouTube). You are responsible for complying with their terms and policies. We are not liable for any actions taken by these platforms, including account suspension or content removal.</p>

      <h2>7. Intellectual Property</h2>
      <p>All rights, title, and interest in UrPoster, including its design, code, and branding, belong to us. You may not copy, modify, or distribute any part of the Service without our written permission.</p>

      <h2>8. Privacy</h2>
      <p>Your use of UrPoster is subject to our Privacy Policy, which explains how we collect, use, and protect your data. By using the Service, you consent to our data practices as described in the Privacy Policy.</p>

      <h2>9. Limitation of Liability</h2>
      <p>To the fullest extent permitted by law:</p>
      <ul>
        <li>UrPoster is provided "as is" without warranties of any kind, express or implied.</li>
        <li>We are not liable for any indirect, incidental, or consequential damages arising from your use of the Service, including loss of data, profits, or business opportunities.</li>
        <li>Our total liability for any claim shall not exceed $100.</li>
      </ul>

      <h2>10. Indemnification</h2>
      <p>You agree to indemnify and hold us harmless from any claims, losses, or damages arising from your use of UrPoster, your User Content, or your violation of these Terms or third-party rights.</p>

      <h2>11. Termination</h2>
      <p>We may terminate or suspend your access to UrPoster at our discretion, with or without notice, for any reason, including violation of these Terms. Upon termination, your right to use the Service will cease, but these Terms will continue to apply to past use.</p>

      <h2>12. Changes to Terms</h2>
      <p>We may update these Terms from time to time. We will notify you of significant changes by posting the updated Terms on our website. Your continued use of the Service after such changes constitutes acceptance of the new Terms.</p>

      <h2>13. Governing Law</h2>
      <p>These Terms are governed by the laws of the State of California, USA, without regard to its conflict of law principles. Any disputes will be resolved exclusively in the state or federal courts located in San Francisco, California.</p>

      <h2>14. Contact Us</h2>
      <p>If you have questions about these Terms, please contact us at:</p>
      <ul>
        <li><strong>Email</strong>: support@urposter.com</li>
        <li><strong>Website</strong>: <a href="https://www.urposter.com">https://www.urposter.com</a></li>
      </ul>

      <p>By using UrPoster, you agree to these Terms. Thank you for choosing our Service!</p>
    </div>
  );
};

export default TermsOfService;